// extracted by mini-css-extract-plugin
export default {"products":"products__1HYt5"};
    if(module.hot) {
      // 1790586298468
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  